<template>
	<div>

		<!-- 顶部栏 -->
		<div class="topbar">
			<div>
				<el-input v-model="searchValue" size="small" placeholder="视频标题/视频描述/视频创建者昵称/系列名"
					prefix-icon="el-icon-search" class="search-input" @keyup.enter.native="search()" clearable/>
				<el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
					@click.stop="search()">
					搜索
				</el-button>
				<el-row style="display: flex;padding-top: 20px;">
					<!-- 部位 -->
					<el-col>
						<!-- fixme -->
						<el-select v-model="curCategoryOption" clearable style="padding-right: 20px;"
							@change="curCategoryChange">
							<el-option v-for="item in categoryOptions" :key="item.forumCategoryId"
								:value="item.forumCategoryId" :label="item.categoryName"></el-option>
						</el-select>
					</el-col>
					<!-- 标签 -->
					<!-- <el-col>
						<el-select v-model="curVideoTabOption" clearable style="padding-right: 20px;"
							@change="curVideoTabChagne">
							<el-option v-for="item in videoTabOptions" :key="item.videoTabID"
								:label="item.videoTabTitle" :value="item.videoTabID"></el-option>
						</el-select>
					</el-col> -->
					<!-- 排序 -->
					<el-col>
						<el-select v-model="curSortOption" clearable style="padding-right: 20px;"
							@change="curSortOptionChange">
							<el-option v-for="item in sortOptions" :key="item.value" :value="item.value"
								:label="item.name">
							</el-option>
						</el-select>
					</el-col>
					
					<!-- 删除 -->
					<el-col>
						<el-select v-model="curIsDeleteOption" clearable style="padding-right: 20px;"
							@change="curIsDeleteOptionChange">
							<el-option label="未删除" value="false"></el-option>
							<el-option label="已删除" value="true"></el-option>
						</el-select>
					</el-col>
				</el-row>

			</div>
			<div>
				<el-button type="primary" icon="el-icon-plus" size="small" @click.stop="openAddVideoDialog()">
					新增视频
				</el-button>
				<el-button type="primary" size="small" @click="go2uploadmanager">上传任务</el-button>

			</div>

		</div>
		<!-- 内容 -->
		<el-table border v-loading="loading" :data="allVideoList" :header-cell-style="{ background: '#F5F7FA' }"
			style="width: 100%; margin-bottom: 20px">
			<el-table-column prop="videoID" label="ID" align="center" />
			<el-table-column prop="uploaderInfo" label="上传者" align="center" show-overflow-tooltip>
				<template #default="props">
					<user-info :user="props.row"></user-info>
				</template>
			</el-table-column>
			<el-table-column prop="videoFaceUrl" label="视频" align="center">
				<template #default="props">
					<div style="width: 100px; height: 100px;position: relative;">
						<el-image style="width: 100px; height: 100px;" fit="scale-down" :key="props.row.videoFaceUrl"
							:src="getImageUrl(props.row.videoFaceUrl)">
							<template #error>
								<p></p>
							</template>
						</el-image>
						<i class="el-icon-video-play"
							style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: aliceblue;"
							@click.stop="previewVideo(props.row)"></i>

					</div>
				</template>

			</el-table-column>
			<el-table-column prop="videoName" label="视频标题" align="center" show-overflow-tooltip />

			<el-table-column prop="videoCategory" label="视频类型" align="center" />
			<el-table-column v-if="userDataTypeOptions.length > 0" label="所属领域" align="center">
				<template slot-scope="scope">
					{{ scope.row.userDataType | userDataTypeTransform }}
				</template>
			</el-table-column>
			<el-table-column prop="videoTabList" label="视频标签" align="center">
				<template #default="props">
					<div v-if="props.row.videoTabList !== null">
						<el-col v-for="item in props.row.videoTabList">
							<el-tag>{{item.videoTabTitle}}
							</el-tag>
						</el-col>
					</div>

				</template>
			</el-table-column>
			<el-table-column label="分享方式" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					{{
		        scope.row.shareMode | simgpleVideoShareModeTransform
		      }}
				</template>
			</el-table-column>
			<!-- <el-table-column prop="videoSize" label="视频大小(M)" align="center">
				<template slot-scope="scope">
					{{ (scope.row.videoSize / 1024 / 1024).toFixed(2) }}
				</template>
			</el-table-column> -->
			<el-table-column prop="price" label="观看费用" align="center" />
			<el-table-column prop="watchCount" label="观看数" align="center" />
			<el-table-column prop="commentCount" label="评论数" align="center" />
			<el-table-column prop="likeCount" label="点赞数" align="center" />

			<el-table-column label="操作" align="center" width="300">
				<template slot-scope="scope">
					<el-button size="small" :type="scope.row.isEssential ? 'warning' : 'success'"
						@click.stop="setVideo(scope.row)">
						{{ scope.row.isEssential ? "取消精华" : "设为精华" }}
					</el-button>
					<!-- <el-button
		        size="small"
		        :type="scope.row.AuditStatus ? 'success' : 'warning'"
		        @click.stop="certificationExpert(scope.$index, scope.row)"
		      >
		        {{ scope.row.AuditStatus ? '通过审核' : '取消通过' }}
		      </el-button> -->
					<el-button size="small" type="primary" @click.stop="goToVideoDetail(scope.row)">
						编辑
					</el-button>
					<el-button size="small" :type="scope.row.isDeleted ? 'warning' : 'danger'"
						@click.stop="deleteOrBackVideo(scope.row)">
						{{ scope.row.isDeleted ? "恢复" : "删除" }}
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination v-show="totalCount > pageSize" background layout="prev, pager, next" :total="totalCount"
			:page-size="pageSize" :current-page="currentPage" @current-change="currentChange" />


		<!-- 预览 -->
		<el-dialog title="预览" :visible.sync="previewVideoDialog" width="65%" :destroy-on-close='true'>
<!--			<video :src="videoSrc" controls style="width: 100%"></video>-->
      <tx-video-player style="height: 60vh" :video-url="videoSrc"></tx-video-player>
		</el-dialog>
		<!-- addVideoDialog -->
		<el-dialog title="新增视频" :visible.sync="addVideoDialog" v-loading="addVideoLoading" width="60%"
			@close="addVideoDlgClose">
			<el-form ref="videoFormRef" :model="addVideoForm" label-width="120px">
				<el-form-item label="视频标题" prop="videoName"
					:rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
					<el-input v-model="addVideoForm.videoName" />
				</el-form-item>
				<el-form-item label="视频描述" prop="videoDesc">
					<el-input v-model="addVideoForm.videoDesc" type="textarea" />
				</el-form-item>
				<div style="height: 60vh;overflow: auto;">
					<el-form-item label="观看条件" prop="payStatus"
						:rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
						<el-radio-group v-model="addVideoForm.payStatus">
							<el-radio :label="0">免费</el-radio>
							<el-radio :label="1">付费</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="费用" v-show="isNeedToPay">
						<el-input v-model="addVideoForm.price" type="number"></el-input>
					</el-form-item>
					<el-form-item label="是否在视频病例界面隐藏" prop="isHideOnMain">
						<el-switch v-model="addVideoForm.isHideOnMain"></el-switch>
					</el-form-item>
					<!-- fixme -->
					<el-form-item label="视频类型" prop="categoryID"
						:rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
						<el-select v-model="addVideoForm.categoryID" style="width: 100%">
							<el-option v-for="item in categoryOptions" :key="item.forumCategoryId"
								:label="item.categoryName" :value="item.forumCategoryId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="userDataTypeOptions.length < 0" label="帖子所属领域" prop="userDataType"
						:rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
						<el-select v-model="addVideoForm.userDataType" style="width: 100%">
              <el-option v-for="item in userDataTypeOptions" :value="item.value" :key="item.value" :label="item.name"></el-option>
            </el-select>
					</el-form-item>
					<el-form-item label="分享方式" prop="shareMode"
						:rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
						<el-select v-model="addVideoForm.shareMode" style="width: 100%">
							<el-option label="个人：只有自己能看" :value="0" />
							<el-option label="尊享：试看，有券能观看" :value="1" />
							<el-option label="公开：不需要用券就可以观看" :value="2" />
						</el-select>
					</el-form-item>
					<el-form-item label="视频标签">
						<el-select v-model="selectedVideoTags" style="width: 100%" multiple filterable>
							<el-option v-for="item in videoTabOptions" :key="item.videoTabID"
								:label="item.videoTabTitle" :value="item.videoTabID" />
						</el-select>
					</el-form-item>
					<el-form-item label="所属栏目" prop="maiColumnID"
						:rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
						<el-select v-model="addVideoForm.maiColumnID" style="width: 100%">
							<el-option v-for="item in maiColumnList" :key="item.maiColumnID" :label="item.columnName"
								:value="item.maiColumnID" />
						</el-select>
					</el-form-item>
					<el-form-item label="上传视频">
						<el-upload ref="uploadVideoRef" accept=".mp4" action="" class="upload-demo" :auto-upload="false"
							:on-change="uplaodVideoChange" :limit="1">
							<div style="text-align: left;">
								<video id="upvideo" v-if="uploadVideoFile !== null" :src="uploadVideoFileURL " controls
									style="width: 100%;height: 30vh;overflow: auto;" /><br />
								<el-button size="small" type="primary">点击上传</el-button>
							</div>

							<div slot="tip" class="el-upload__tip">
								只能上传mp4文件
							</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="试看时长(单位：秒)" prop="tryTimeLength"
						:rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
						<el-input v-model="addVideoForm.tryTimeLength" type="number"></el-input>
					</el-form-item>
					<el-form-item label="上传封面">
						<el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
							:on-change="uplaodCoverChange" :auto-upload="false">
							<div style="text-align: left;">
								<el-image v-if="uploadCoverFile !== null" style="width: 100px; height: 100px"
									:src="uploadCoverFileURL" fit="scale-down">
									<template #error>
										<p></p>
									</template>
								</el-image><br />
								<el-button size="small" type="primary">点击上传</el-button>
							</div>

							<div slot="tip" class="el-upload__tip">
								只能上传jpg/png文件
							</div>
						</el-upload>
					</el-form-item>
				</div>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="addVideoDialog = false">
					取 消
				</el-button>
				<el-button type="primary" size="small" @click="handleAddVideo()">
					确 定
				</el-button>
			</div>
		</el-dialog>

		<canvas id="mycanvas" style="display: none"></canvas>
	</div>


</template>

<script>
	import {
		addTask
	} from "@/utils/uploadManager"
	import {
		getAllVideoList,
		setVideo,
		addVideo,
		deleteOrBackVideo,
		getVideoTabList,
		setVideoTab,
		addVideoTab,
		updateVideoTab,
		deleteVideoTab,
		getCategoryList
	} from "@/api/videoCourse";
	import {
		getOSSUploadInfo
	} from "@/api/aliyun";
	import config from "@/utils/config";
	import {
		isVaild
	} from "@/utils/validate"
	import {
		getCloudUrl,
		getLocalFileURL
	} from "@/utils/urlutil"
  import {
    getDisplayName, getUserType
  } from "@/utils/userutil"
	import {
		uploadFile2OSS
	} from "@/utils/OSSUpload"
	import {
		printObj
	} from "@/utils/debug"
	import {
		deepClone
	} from "@/utils/index"
	import {
		getMaiColumnList
	} from "@/api/system/columnManagement/index"
	import {
		handleRes
	} from "@/utils/handleRes"
  import UserInfo from "@/components/UserInfo/UserInfo";
  import TxVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";
  import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
	export default {
    components: {TxVideoPlayer, UserInfo},
    data() {
			return {
        navigationKey:"videoCourse",

        userDataTypeOptions:[],
				loading: false, // 加载开关
				addVideoLoading: false, // 添加视频加载开关
				searchValue: "", // 搜索内容
				totalCount: 0, // 列表总数
				pageSize: 10, // 单页条数
				currentPage: 1, // 当前页码
				previewVideoDialog: false, // 预览视频开关
				videoSrc: "", // 视频路径
				allVideoList: [], // 所有视频列表
				addVideoDialog: false, // 添加视频开关
				addVideoForm: {}, // 添加视频表单
				selectedVideoTags: [],
				// 视频标签选项列表
				videoTabOptions: [],
				curVideoTabOption: "",
				curCategoryOption: "",
				categoryOptions: [],
				sortOptions: [{
					name: "按时间排序",
					value: "CreateTime"
				}, {
					name: "按播放量排序",
					value: "WatchCount"
				}],
				curSortOption: "",
				curIsDeleteOption:"",
				//上传视频、封面相关
				uploadCoverFile: null,
				uploadVideoFile: null,
				uploadVideoTimeLength: 0,
				uploadCoverFromVideo: "",
				uploadCoverFileURL: "",
				uploadVideoFileURL: "",
				maiColumnList: []
			}
		},
		computed: {
			isNeedToPay: function() {
				if (this.addVideoForm.payStatus === 1) {
					return true;
				} else {
					return false;
				}
			},
		},
		async created() {
      let navigationObj = getNavigationItemObj(this.navigationKey)
      this.currentPage = navigationObj.currentPage
      this.curIsDeleteOption = navigationObj.curIsDeleteOption
      this.curSortOption = navigationObj.curSortOption
      this.searchValue = navigationObj.searchValue
      this.curCategoryOption = navigationObj.curCategoryOption

      this.userDataTypeOptions = getUserType()
			this.getAllVideoList()
			this.getCategoryList()
			const res = await this.getAllVideoTabList();
			this.videoTabOptions = res.map((item) => {
				return {
					videoTabID: item.videoTabID,
					videoTabTitle: item.videoTabTitle,
				};
			});
			

		},
		methods: {
			curIsDeleteOptionChange(){
				this.search()
			},
			go2uploadmanager() {
				this.$router.push({
					name: "uploadManage",
				})
			},
			addVideoDlgClose() {
				this.uploadCoverFile = null
				this.uploadCoverFileURL = ""
				this.uploadVideoFile = null
				this.uploadVideoFileURL = ""
				this.uploadVideoTimeLength = 0
			},
			getVideoDuration(url) {

				return new Promise((reslove) => {
					let video = document.createElement('video');
					video.preload = 'metadata';
					video.src = url;
					video.onloadedmetadata = () => {
						reslove(parseInt((video.duration * 1000).toString(), 10));
						video = null;
					};
				});
			},
			getVideoCover(url) {
				const video = document.getElementById("upvideo"); // 获取视频对象
				// const video = document.createElement("video") // 也可以自己创建video
				// console.log('----- getVideoCover ' + video)
				video.src = url; // url地址 url跟 视频流是一样的
				var canvas = document.getElementById("mycanvas"); // 获取 canvas 对象
				const ctx = canvas.getContext("2d"); // 绘制2d
				video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
				video.currentTime = 1; // 第一帧
				video.oncanplay = () => {
					canvas.width = video.clientWidth; // 获取视频宽度
					canvas.height = video.clientHeight; //获取视频高度
					// 利用canvas对象方法绘图
					ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
					// 转换成base64形式
					this.imgsrc = canvas.toDataURL("image/png"); // 截取后的视频封面
					this.uploadCoverFromVideo = this.imgsrc;
					// console.log(this.uploadCoverFromVideo)
				};
			},
			async uplaodVideoChange(uploadFile) {
				this.$refs.uploadVideoRef.clearFiles()
				this.uploadVideoFile = uploadFile
				this.uploadVideoFileURL = getLocalFileURL(uploadFile)
				let duration = await this.getVideoDuration(this.uploadVideoFileURL);
				this.uploadVideoTimeLength = duration / 1000;
				// console.log("upload video time length " + this.uploadVideoTimeLength)
				this.getVideoCover(this.uploadVideoFileURL)
			},
			uplaodCoverChange(uploadFile) {
				this.$refs.uploadCoverRef.clearFiles();
				this.uploadCoverFile = uploadFile;
				this.uploadCoverFileURL = getLocalFileURL(uploadFile);
			},
			getName(user) {
				return getDisplayName(user)
			},
			getImageUrl(path) {
				return getCloudUrl(path)
			},
			curSortOptionChange() {
				this.search()
			},
			curVideoTabChagne() {
				this.search()
			},
			async getCategoryList() {
				let getCategoryRes = await getCategoryList()
				if (isVaild(getCategoryRes)) {
					this.categoryOptions = getCategoryRes.data
				}
			},
			curCategoryChange() {
				this.search()
			},
			/**
			 * 获取所有视频列表
			 */
			getAllVideoList() {
				this.loading = true;
				const params = {
					// Type: 0,
					// userDataType: 0,
					// sortName: 'createTime',
					// sortOrder: 'asc',
					pageNumber: this.currentPage || 1,
					pageSize: this.pageSize || 10,
					keyWord: this.searchValue || "",
					sortName: this.curSortOption
				};
				var where = []
				if (isVaild(this.curCategoryOption)) {
					where.push({
						"field": "categoryID",
						"value": this.curCategoryOption,
						"op": "equal"
					})
				}
				if(isVaild(this.curIsDeleteOption)){
					where.push({
						"field": "isDeleted",
						"value": this.curIsDeleteOption,
						"op": "equal"
					})
				}
				// if(isVaild(this.curVideoTabOption)){
				// 	where.push({
				// 		"field": "videoTabList",
				// 		"value": this.curVideoTabOption,
				// 		"op": "equal"
				// 	}) 
				// }
				if (where.length > 0) {
					params.where = where
				}
        setNavigationItemWithObj(this.navigationKey,{
          currentPage:this.currentPage,
          searchValue:this.searchValue,
          curSortOption:this.curSortOption,
          curCategoryOption:this.curCategoryOption,
          curIsDeleteOption:this.curIsDeleteOption
        })

				getAllVideoList(params).then((res) => {
					this.allVideoList = res.data.rows;
					this.totalCount = res.data.total;
					this.loading = false;
				});
			},

			/**
			 * 预览视频
			 *
			 * @param {object} row 所选对象信息
			 */
			previewVideo(row) {
				this.previewVideoDialog = true;
				this.videoSrc = getCloudUrl(row.videoUrl);
			},

			/**
			 * 搜索
			 */
			search() {
				this.currentPage = 1;
				this.getAllVideoList();
			},
			/**
			 * 翻页
			 *
			 * @param {number} currentPage 当前页码
			 */
			currentChange(currentPage) {
				this.currentPage = currentPage;
				this.getAllVideoList();
			},
			/**
			 * 跳转到视频详情
			 *
			 * @param {object} row 所选对象信息
			 */
			goToVideoDetail(row) {
				this.$router.push({
					path: "videoDetail",
					query: {
						videoID: row.videoID,
					},
				});
			},

			/**
			 * 打开添加视频对话框
			 */
			async openAddVideoDialog() {
				// 清空选项
				this.selectedVideoTags = [];
				// 获取栏目信息
				const res = await getMaiColumnList({
					type: 1
				});
				handleRes(res,()=>{
					this.maiColumnList = res.data;
				})
				

				this.addVideoDialog = true;
				this.addVideoForm = {
					price: 0,
					isHideOnMain: false
				};
				this.$nextTick(() => {
					this.$refs["videoFormRef"].clearValidate();
				});
			},
			/**
			 * 设置视频状态
			 *
			 * @param {object} row 所选对象信息
			 */
			setVideo(row) {
				const params = {
					videoID: row.videoID,
					type: row.isEssential ? 0 : 1, // 视频状态，0：取消精华。1：设为精华
				};
				setVideo(params).then((res) => {
					if (res.code === 200) {
						this.$message({
							message: "操作成功",
							type: "success",
						});
						this.getAllVideoList();
					} else {
						this.$message({
							message: res.message,
							type: "warning",
						});
					}

				});
			},
			/**
			 * 删除/恢复视频
			 *
			 * @param {object} row 所选对象信息
			 */
			deleteOrBackVideo(row) {
				// 判断操作类型
				let tips1, tips2;
				if (row.isDeleted) {
					tips1 = "是否恢复该视频课程";
					tips2 = "恢复成功!";
				} else {
					tips1 = "是否删除该视频课程";
					tips2 = "删除成功";
				}

				const params = {
					videoID: row.videoID,
				};
				this.$confirm(tips1, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						deleteOrBackVideo(params).then((res) => {
							if (res.code === 200) {
								this.$message({
									type: "success",
									message: tips2,
								});
								this.getAllVideoList();
							} else {
								this.$message({
									message: res.message,
									type: "warning",
								});
							}

						});
					})
					.catch(() => {
						this.$message("取消操作");
					});
			},
			/**
			 * 获取所有视频标签选项
			 */
			getAllVideoTabList() {
				this.loading = true;
				const params = {
					// sortName: "",
					// sortOrder: "",
					pageNumber: 1,
					pageSize: 10,
				};
				// 秀一下链式调用
				// 第一次调用拿到 totalCount，然后通过 totalCount 拿到全部视频标签
				const data = getVideoTabList(params)
					.then((res) => {
						return res.data.total;
					})
					.then((res) => {
						return getVideoTabList({
							pageNumber: 1,
							pageSize: res
						});
					})
					.then((res) => {
						this.utils.stopLoading(this);
						return res.data.rows;
					});
				return data;
			},
			/**
			 * 提交新增视频
			 */
			async handleAddVideo() {
				this.$refs["videoFormRef"].validate(async (valid) => {
					if (valid) {

						if (!isVaild(this.uploadVideoFile)) {
							this.$message.warning("请选择上传视频")
							return
						}

						this.addVideoLoading = true;
						this.addVideoForm.videoTimeLength = this.uploadVideoTimeLength

						//FIXME：获取上传路径
						let savepathParamsRes = await getOSSUploadInfo({
							DataType: "10",
							ID: "0",
						});
						if (!isVaild(savepathParamsRes)) {
							return;
						}
						let savePathParams = savepathParamsRes.resultData

						//传封面

						if (isVaild(this.uploadCoverFile) || isVaild(this.uploadCoverFromVideo)) {

							// printObj(this.uploadCoverFile.raw)
							let timestamp = new Date().valueOf();


							let uploadRes;
							let fileName;
							//有上传封面
							if (isVaild(this.uploadCoverFile)) {
								fileName = savePathParams.PicSavePath + timestamp + this
									.uploadCoverFile.name.substring(this
                        .uploadCoverFile.name.lastIndexOf("."));
								// console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
								uploadRes = await uploadFile2OSS(savePathParams, new Blob([this
									.uploadCoverFile.raw
								], {
									type: this.uploadCoverFile.raw.type
								}), fileName)

							} else if (isVaild(this.uploadCoverFromVideo)) {
								let data = this.uploadCoverFromVideo
								var str = data.split(",");
								var suffix = data.split(";")[0].split("/")[1];
								// console.log("IMG-Suffix====>>", suffix)
								fileName = savePathParams.PicSavePath + "cover_from_video_" +
									timestamp + "." + suffix;
								// console.log("upload info " + savePathParams.PicSavePath + " " + fileName)

								//base64
								var buffer = Buffer.from(str[1], 'base64');
								uploadRes = await uploadFile2OSS(savePathParams, buffer, fileName)
							}
							if (uploadRes.status === 0) {
								this.addVideoForm.videoFaceUrl = "/" + fileName
								// console.log(this.addVideoForm.videoFaceUrl)
							} else {
								this.$message({
									type: "error",
									message: "上传失败"
								})
								return
							}
							this.$refs.uploadVideoRef.clearFiles();
						}


						this.addVideoForm.videoTabIDs = this.selectedVideoTags.join();
						let data = deepClone(this.addVideoForm)

						//传视频
						if (isVaild(this.uploadVideoFile)) {
							//视频比较大，后台上传
							this.addVideoLoading = false;
							data.videoSize = this.uploadVideoFile.raw.size
							let timestamp = new Date().valueOf();
							const fileName = savePathParams.PicSavePath + timestamp + this
								.uploadVideoFile.name.substring(this
                      .uploadVideoFile.name.lastIndexOf("."));
							// console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
							let uploadRes = await addTask({
								from: "视频课程",
								ossInfo: savePathParams,
								file: new Blob([this
									.uploadVideoFile.raw
								], {
									type: this.uploadVideoFile.raw.type
								}),
								filePath: fileName,
								orgName: this.uploadVideoFile.name,
								finishCallback: async (uploadInfo) => {
									data.videoUrl = "/" + fileName
									// printObj(data)
									let res = await addVideo(data)
									if (res.code === 200) {
										uploadInfo.status = 3
									} else {
										uploadInfo.status = 2
										uploadInfo.remarks = res.message
									}
								}
							}, (status) => {
								if (status.status === 0) {

									this.addVideoDialog = false;
									this.$message.success("已添加到上传任务")
								} else {
									this.$message.warning(status.msg)
								}
							})
							// let uploadRes = await uploadFile2OSS(savePathParams, new Blob([this
							// 	.uploadVideoFile.raw
							// ], {
							// 	type: this.uploadVideoFile.type
							// }), fileName)

							// if (uploadRes.status === 0) {
							// 	data.videoUrl = "/" + fileName
							// 	// console.log(this.addVideoForm.PushFlowURL)
							// } else {
							// 	this.$message({
							// 		type: "error",
							// 		message: "上传失败"
							// 	})
							// 	return
							// }
							// this.$refs.uploadCoverRef.clearFiles();
						}



						// printObj(this.addVideoForm)

						// const res = await addVideo(data);
						// if (res.code === 200) {
						// 	this.$message.success("操作成功");
						// 	this.addVideoDialog = false;
						// 	this.getAllVideoList();
						// } else {
						// 	this.$message.warning(res.message);
						// }
						// this.addVideoLoading = false;
					}
				});
			},
		},
	}
</script>

<style>
	.center {
		width: 100px;
		height: 100px;
	}

	.close {
		position: absolute;
		top: 50%;
		left: 50%;
	}
</style>
